// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2eneZ","tab":"ProcedureTabs_tab__2Vrmi"};